import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Typography, Container, Box, Alert } from '@mui/material';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';

function LoginPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { login } = useAuth();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [forgotEmail, setForgotEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            const response = await api.post('/user/signin', { username, password });
            const { token, expiresAt } = response.data;
            login(token, expiresAt);
            setMessage(t('common.signInSuccess'));
            navigate('/dashboard');
        } catch (err) {
            setError(t('common.errorOccurred', { message: err.response?.data?.message || err.message }));
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        try {
            await api.post('/user/forgot-password', { email: forgotEmail });
            setMessage(t('common.forgotPasswordSuccess'));
        } catch (err) {
            setError(t('common.errorOccurred', { message: err.response?.data?.message || err.message }));
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    {t('common.login')}
                </Typography>
                {message && <Alert severity="success" sx={{ mt: 2, width: '100%' }}>{message}</Alert>}
                {error && <Alert severity="error" sx={{ mt: 2, width: '100%' }}>{error}</Alert>}
                <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label={t('common.username')}
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={t('common.password')}
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        {t('common.login')}
                    </Button>
                    <Link to="/register" style={{ textDecoration: 'none' }}>
                        <Button fullWidth variant="outlined" sx={{ mb: 2 }}>
                            {t('common.register')}
                        </Button>
                    </Link>
                </Box>

                <Typography component="h2" variant="h6" sx={{ mt: 4 }}>
                    {t('common.forgotPassword')}
                </Typography>
                <Box component="form" onSubmit={handleForgotPassword} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="forgotEmail"
                        label={t('common.email')}
                        name="email"
                        autoComplete="email"
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        {t('common.forgotPassword')}
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

export default LoginPage;